import {
  TableHeaderDefinitionCellType,
  TableCell,
} from '~/components/organism/Table/types';
import { BaseHeaderCellOptions } from '../asBaseCell';
import { asBaseOptions } from '../asBaseCell';

type StringHeaderCellOptions = BaseHeaderCellOptions & {
  renderFunction?: StringRenderFunction;
};

export type StringRenderFunction = (
  value: string,
  tableCell: TableCell<string>,
) => React.ReactNode;

const asStringTableHeaderCell = ({
  renderFunction,
  ...rest
}: StringHeaderCellOptions): TableHeaderDefinitionCellType<string> => {
  let options = asBaseOptions({
    ...rest,
  });

  if (renderFunction != null) {
    options = {
      ...options,
      Cell: (tableCell: TableCell<string>) =>
        renderFunction(tableCell.cell.value, tableCell),
    };
  }

  return options;
};

export default asStringTableHeaderCell;
